import React from 'react';
import { EditMenu } from './edit-menu';
import { EditButton } from './edit-button';
import { BusyIndicator } from './busy-indicator';

export const Menu = () => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '5px',
            alignItems: 'center',
            justifyContent: 'flex-end',
        }}>
            <EditMenu />
            <EditButton />
            <BusyIndicator />
        </div>
    );
};
